import React from 'react';
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  description,
  actions
}: PageHeaderProps) {
  return <div className="border-b border-border bg-card px-6 py-5" data-id="element-562" data-mp="149h3th7w2xze">
      <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-563" data-mp="zbpacirlj3t3">
        <div className="min-w-0" data-id="element-564" data-mp="zdjkr358rdix">
          {eyebrow && <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground" data-id="element-565" data-mp="uddxs09x2f76">
              {eyebrow}
            </p>}
          <h1 className="mt-1 text-xl font-semibold tracking-tight text-foreground" data-id="element-566" data-mp="lk22rms7e8v0">{title}</h1>
          {description && <p className="mt-1.5 max-w-3xl text-[13px] leading-relaxed text-muted-foreground" data-id="element-567" data-mp="glqsjaxzxwc9">
              {description}
            </p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2" data-id="element-568" data-mp="6mrvyqqi9r5m">{actions}</div>}
      </div>
    </div>;
}